// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"362d44d0","204":"949c5abc","309":"4eba60ff","353":"fe285768","411":"f6423c40","423":"72897c81","452":"42143363","470":"67e6c2e0","569":"d353e099","657":"d9923239"}[chunkId] + ".chunk.js";
};